import {Injectable} from '@angular/core';

@Injectable()
export class WipService {

    // Gets or sets the work in progress data
    private wipData: any;

    // Gets or sets the current payment method type
    public paymentMethodTypeId: number;

    // Gets or sets the current cash drawer id
    public cashDrawerId: number;

    // Gets or sets the return route url
    public returnRoute: string;

    constructor() {
    }

    // Gets the current wip rollup balance data
    public getWipData(): any {
        return this.wipData;
    }

    // Sets the current wip rollup balance data
    public setWipData(wipData: any) {
        this.wipData = wipData;
    }

    // Clears the wipData
    public clearWipData() {
        this.wipData = null;
    }
}
